import React from 'react'
import { useTranslation } from 'react-i18next';

type Props = {
    onSelect: Function,
    selected?: string,
    isRenewalVariant: boolean,
    quantity: number
}

export default function Qty(props: Props) {
    const {
        onSelect,
        isRenewalVariant,
        quantity,
    } = props;

    const { t } = useTranslation(['checkout', 'common'])

    const handleSelect = (event: React.ChangeEvent<HTMLSelectElement|HTMLInputElement>) => {
        onSelect(event);
    };

    return (
        <div className="qty-div">
            <span className="qty-title">{t('purchase.qty', {ns: 'common'})}:</span>
            {quantity >= 10 ? (
                <input
                    disabled={isRenewalVariant}
                    id="purchase-qty"
                    name="quantity"
                    type="number"
                    className="form-control"
                    onChange={handleSelect}
                    value={quantity}
                />
            ) : (
                <select
                    disabled={isRenewalVariant}
                    id="purchase-qty"
                    name="quantity"
                    className="form-control"
                    onChange={handleSelect}
                    value={quantity}
                >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, '10+'].map((qty) => (
                        <option key={qty} value={qty}>
                            {qty}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
}